import React, { useContext, useReducer, useRef, useState } from 'react';
import { Card, Form, InputNumber, Select } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import { FormFieldPath } from './index';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {

    return {
        Renderer: (props) => {

            const [, forceUpdate] = useReducer((x) => x + 1, 0)
            const [operations, setOperations] = useState(null)
            const fields = useRef([])
            const formFieldPath = useContext(FormFieldPath)

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }
            const { data } = props
            const liveRender = (props.isPreviewMode || formPlugin.live)

            if (formPlugin.formData.type !== "COMPLEX") {
                if (props.remove) {
                    props.remove()
                }
                return null
            }

            if (!data.productId) {
                if (formPlugin.live) {
                    return null
                }
                return (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        color: "red"
                    }}>
                        <Trans>Veuillez sélectionner un produit.</Trans>
                    </div>
                )
            }

            const product = formPlugin.formData.products.find(i => i.id === data.productId)

            if (!liveRender) {
                return (
                    <div>
                        <div style={{ border: "1px dashed orange", borderRadius: 10, padding: "2%" }}>
                            <Card title={t`Information Complémentaire (${product.label})`} type="inner">
                                {props.children}
                            </Card>
                        </div>
                    </div>
                )
            }

            let afterProduct = data?.afterProduct || 1

            const quantity = formPlugin?.formRef?.getFieldValue(product.id + "_quantity") || 0

            if (quantity < afterProduct) {
                return false
            }

            return (
                <div>
                    <Form.List name={data.productId}>
                        {(fs, ops) => {
                            fields.current = fs
                            if (!operations && ops) {
                                setOperations(ops)
                            }

                            return (
                                <div>
                                    {[...Array(quantity - (afterProduct - 1)).keys()].map((index) => {
                                        const _field = {
                                            fieldKey: index,
                                            isListField: true,
                                            key: index,
                                            name: index,
                                        }

                                        return (
                                            <FormFieldPath.Provider value={{ path: formFieldPath.path.concat([data.productId, index]) }}>
                                                <Card
                                                    key={_field.key}
                                                    title={t`${product.title} #${index + 1 + (afterProduct - 1)}`}
                                                    type="inner"
                                                    style={{ marginBottom: 20 }}
                                                >
                                                    <div key={_field.key} className={"form-field"} data-field={JSON.stringify(_field)}>
                                                        {React.Children.map(props.children, child => React.cloneElement(child))}
                                                    </div>
                                                </Card>
                                            </FormFieldPath.Provider>
                                        )
                                    })}
                                </div>
                            )
                        }}
                    </Form.List>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-product-info' + namespace,
        title: t`Information Complémentaire`,
        description: t`Élément de formulaire utilisable.`,
        icon: <FormOutlined />,
        iconColor: "#8E44AD",
        version: 1,
        hideInMenu: formPlugin.formData.type !== "COMPLEX",
        allowClickInside: false,
        ignoreLayoutParams: true,
        cellPlugins: (plugins, data) => {
            if (!data.productId) {
                return []
            }
            const newNamespace = namespace + data.productId + "/"
            formPlugin.registerNamespace(newNamespace, data.productId)

            return formPlugin.getPluginsMem(namespace)
                .filter(i =>
                    !i.id.includes("form-identity") &&
                    !i.id.includes("form-product") &&
                    !i.id.includes("form-step-container") &&
                    !i.id.includes("form-submit-button") &&
                    !i.id.includes("form-free-amount") &&
                    !i.id.includes("form-paiement-method") &&
                    !i.id.includes("form-calendar")
                )
                .map(i => {
                    if (i.id.includes("form")) {
                        i.namespace = newNamespace
                        i.id = i.id + data.productId + "/"
                    }
                    return i
                })
        },
        controls: {
            type: 'custom',
            Component: (props) => {
                const productId = props.data?.productId || null
                const afterProduct = props.data?.afterProduct || 1
                const products = formPlugin.formData.products

                return (
                    <div>
                        <Form.Item label={t`Produit`}>
                            <Select
                                placeholder={t`Choisir un produit`}
                                value={productId}
                                onChange={(v) => props.onChange({ productId: v })}
                            >
                                {products.map(i => (
                                    <Select.Option value={i.id}>
                                        {i.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label={t`Demander à partir du`}>
                            <InputNumber
                                decimalSeparator={','}
                                min={1}
                                step={1}
                                addonAfter={t`Produit(s)`}
                                value={afterProduct}
                                onChange={(v) => props.onChange({ afterProduct: v })}
                            />
                        </Form.Item>
                    </div>
                )
            }
        },
    }
}
